import { useLocation } from "react-router-dom";
import "../proceedView/ProceedView.scss";
import { useEffect } from "react";
import { postMethod } from "../../utils/services/api";
import url from "../../utils/services/url.json";
import "../proceedView/ProceedView.scss";

export default function IdvCompletion() {

   const location = useLocation();

   useEffect(() => {
      if (location?.state?.type === 'demo') {
         handleIdvWebhook()
      }
   }, [location])

   const handleIdvWebhook = async () => {
      const body = {
         "idRequest": location?.state?.uid,
         "reference": location?.state?.uid,
         "is_demo_user": true
      }
      const response = await postMethod(url?.idvWebhook, body);
   }

   return (
      <div className="c2c_poceedView">
         <div className="subContainer">
            <div className="proceedView">
               <div
                  className="box"
                  style={{
                     display: "flex",
                     flexDirection: "column",
                     alignItems: "center",
                     padding: "20px"
                  }}
               >
                  <img
                     src="./c2c-logo.png"
                     alt="c2c logo"
                     style={{
                        width: "120px",
                        height: "80px",
                        objectFit: "contain",
                        marginBottom: "20px"
                     }}
                  />

                  <div className="heading">
                     <h2 className="title">{'ID Verification Completed'}</h2>
                  </div>
                  <ul>
                     <li>
                        <div className="heading">
                           <p className="text" style={{ textAlign: 'left' }}>
                              {'Thank you for completing the ID verification process. Your documents and information have been submitted and recorded in our system.'}
                           </p>
                        </div>
                     </li>
                     <li>
                        <div className="heading">
                           <p className="text" style={{ marginTop: 0, textAlign: 'left' }}>
                              {'Your advisor has been notified and will review the results of your ID verification. They will contact you if any further action is required or to guide you through the next steps.'}
                           </p>
                        </div>
                     </li>
                     <li>
                        <div className="heading">
                           <p className="text" style={{ marginTop: 0, textAlign: 'left' }}>
                              {'If you have any questions in the meantime, please feel free to get in touch with your advisor.'}
                           </p>
                        </div>
                     </li>
                  </ul>
                  <div className="heading">
                     <p className="text" style={{ marginTop: 0 }}>{'Thank you for your cooperation.'}</p>
                  </div>
                  <div className="heading">
                     <p className="text" style={{ marginTop: 0 }}>{'Please close this window.'}</p>
                  </div>
               </div>
            </div>
         </div>

         <div style={{ position: "fixed", bottom: "-8px", width: "100%" }}>
            <p
               style={{
                  display: "flex",
                  justifyContent: "center",
                  color: "#7b7b7b",
                  fontSize: "14px",
                  fontFamily: "Arial",
               }}
            >
               Powered by Click2Check
            </p>
         </div>
      </div>

   )
}